import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-box" }
const _hoisted_2 = { class: "modal-head-slim" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "slim-info" }
const _hoisted_5 = { class: "slim-title" }
const _hoisted_6 = { class: "slim-meta" }
const _hoisted_7 = { class: "slim-date" }
const _hoisted_8 = {
  key: 0,
  class: "slim-author"
}
const _hoisted_9 = ["innerHTML"]

import { watch } from 'vue';
import { AnOutlinedClose } from "@kalimahapps/vue-icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'AnnouncementModal',
  props: { visible: Boolean, announcement: Object },
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const close = () => emit('close');
watch(() => props.visible, (val) => { document.body.style.overflow = val ? 'hidden' : ''; });

const formatDate = (dateString: string) => {
  if (!dateString) return '';
  const d = new Date(dateString); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal-fade" }, {
    default: _withCtx(() => [
      (props.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-overlay",
            onClick: _withModifiers(close, ["self"])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("button", {
                class: "close-btn",
                onClick: close
              }, [
                _createVNode(_unref(AnOutlinedClose))
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: __props.announcement?.cover_image,
                  class: "slim-cover"
                }, null, 8, _hoisted_3),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.announcement?.title), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(formatDate(__props.announcement?.published_at)), 1),
                    (__props.announcement?.author)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, " | By: " + _toDisplayString(__props.announcement.author), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: "modal-body wangeditor-content",
                innerHTML: __props.announcement?.content
              }, null, 8, _hoisted_9)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})